import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListadoArchivosTemporalesComponent } from '../views/archivos-temporales/listado-archivos-temporales/listado-archivos-temporales.component';
import { SharedModule } from 'src/app/modules/shared.module';
import { DateRangePickerComponent } from '@helpers/DateRangePicker/DateRangePicker.component';



@NgModule({
  declarations: [DateRangePickerComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports:[DateRangePickerComponent]
})
export class HelperModule { }
